export const convertNoteHTML = (payload: string) => {
    const div = document.createElement('div')
    div.innerHTML = payload
    const mentions = div.getElementsByClassName('mention')
    const tags = div.getElementsByClassName('tag')
    const lesdoelen = div.getElementsByClassName('lesdoel')

    for (let i = 0, max = mentions.length; i < max; i++) {
        const tagId = (mentions[i] as HTMLElement).dataset.tag
        mentions[i].innerHTML = `@${tagId}`
    }
    for (let i = 0, max = tags.length; i < max; i++) {
        const tagId = (tags[i] as HTMLElement).dataset.tag
        const tagName = (tags[i] as HTMLElement).dataset.name

        if (tagId === '-1') {
            tags[i].innerHTML = `#${tagName}`
        } else {
            tags[i].innerHTML = `{${tagId}`
        }
    }
    for (let i = 0, max = lesdoelen.length; i < max; i++) {
        const lesdoelId = (lesdoelen[i] as HTMLElement).dataset.lesdoel
        const lesdoelName = (lesdoelen[i] as HTMLElement).dataset.name

        if (lesdoelId === '-1') {
            lesdoelen[i].innerHTML = `&${lesdoelName}`
        } else {
            lesdoelen[i].innerHTML = `&${lesdoelId}`
        }
    }

    const text = div.innerHTML.replace(/(<([^>]+)>)/gi, ' ')
    const textNoDoubleSpaces = text.replace(/ +(?= )/g, '')
    return textNoDoubleSpaces.trim()
}
